import { render, staticRenderFns } from "./DocumentBox.vue?vue&type=template&id=12084cb2"
import script from "./DocumentBox.vue?vue&type=script&lang=js"
export * from "./DocumentBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports